const cyberteam = [
    {
        name: "Alan George",
        title: "Cyber",
        imageSrc: "/images/committee/cyber/Alan_George.jpg",
        socials:{},
    },
    {
        name: "Jeniel Shah",
        title: "Cyber",
        imageSrc: "/images/committee/cyber/Jeniel_Shah.jpg",
        socials: {},
    },
    {
        name: "Smit Shah",
        title: "Cyber",
        imageSrc: "/images/committee/cyber/Smit_Shah.jpg",
        socials:{},
    },
    {
        name: "Utsav Parekh",
        title: "Cyber",
        imageSrc: "/images/committee/cyber/Utsav_Parekh.jpg",
        socials:{},
    },
    
]

export default cyberteam;